import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenter,
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { ButtonWithRequest } from './ButtonWithRequest';
import { formatPrice, round } from '../../../utilities';
import { __ } from 'react-i18n';
import { SmallLoader } from '../General/SmallLoader';

interface Props {
  price: string;
  isSale: number | boolean;
  oldPrice: string;
  salePercentage: string;
  avail_id: number;
  addToRequest: any;
  addToCart: any;
  product?: any;
  currency: string;
  canOrder?: boolean;
  forbiddenOrder?: boolean;
  loadingPrices?: boolean;
  hasUser?: boolean;
  cannotOrderButtonText?: string;
  isNew?: boolean;
  isWaiting?: boolean;
  hiddenSale?: boolean;
  addToCompare?: any;
  displayType?: string;
}

function ProductPriceCart({
  price,
  isSale,
  oldPrice,
  addToCart,
  addToRequest,
  salePercentage,
  avail_id,
  product,
  currency,
  canOrder,
  forbiddenOrder,
  loadingPrices,
  hasUser,
  cannotOrderButtonText,
  isNew,
  isWaiting,
  hiddenSale,
  addToCompare,
  displayType
}: Props) {
  return (
    <Wrapper>
      {avail_id === 11 || !avail_id || price === '0' || price === '0.0' ? (
        <Soon>{__('Už čoskoro')}</Soon>
      ) : (
        <>
          <PriceCol>
            <PriceRow>
              <>
                {round(oldPrice, 2) <= round(price, 2) ?  hiddenSale? <OldPrice> {__("SUPER CENA")} </OldPrice> : null : !!isSale ? (
                  <OldPrice displayType={displayType}>
                    {formatPrice(parseFloat(oldPrice), currency, 2)}
                    {salePercentage ? ` (-${round(salePercentage, 0)}%)` : ''}
                  </OldPrice>
                ) : parseFloat(oldPrice) > 0 ? (
                  <OldPrice displayType={displayType}>
                    {formatPrice(parseFloat(oldPrice), currency, 2)}
                    {salePercentage ? ` (-${round(salePercentage, 0)}%)` : ''}
                  </OldPrice>
                ) : null}
                {price && +price > 0 ? (
                  <Price displayType={displayType}>{formatPrice(parseFloat(price), currency, 2)}</Price>
                ) : (
                  <Soon>{__('Už čoskoro')}</Soon>
                )}
                {/* {loadingPrices && (
                  <LoaderWrapper>
                    <SmallLoader
                      title={__('Prebieha načítanie cien')}
                      small={true}
                      primaryColor={true}
                    />
                  </LoaderWrapper>
                )} */}
              </>
            </PriceRow>
          </PriceCol>
          {!forbiddenOrder? <ButtonWithRequest
            onButtonClick={addToCart}
            onRequestClick={addToRequest}
            avail_id={avail_id}
            product={product}
            count={0}
            canOrder={canOrder}
            hideCart={price === '0' || !price}
            hasUser={hasUser}
            cannotOrderButtonText={cannotOrderButtonText}
            isNew={isNew}
            isWaiting={isWaiting}
            addToCompare={addToCompare}
          /> : <></> }
        </>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenter)`
  width: 100%;
  height: ${rem(48)};
  margin-bottom: ${rem(8)};
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: ${rem(15)};
`;

const PriceCol = styled(FlexCol)``;

const PriceRow = styled(FlexRow)`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: ${rem(4)};
  position: relative;
`;

const Price = styled(TextP)<{displayType: string}>`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(24)};
  font-weight: 500;
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(6)};
  white-space: nowrap;

  ${({ theme }) => theme.mediab.m580`
    font-size: ${({ displayType }) => displayType === 'small' ? rem(20) : 'inherit'};
  `}

`;

// const StyledUnit = styled.span`
//   opacity: 0.4;
//   font-size: ${rem(14)};
// `;

const SecondaryText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.placeholder};
`;

const OldPrice = styled(SecondaryText)<{displayType?:string}>`
  color: #ff1e45eb;
  letter-spacing: 0;
  margin-bottom: ${rem(2)};

  ${({ theme }) => theme.mediab.m580`
    font-size: ${({ displayType }) => displayType === 'small' ? rem(12) : 'inherit'};
  `}
`;

const Soon = styled(TextP)`
  width: 100%;
  text-align: center;
  font-size: ${rem(24)};
  font-weight: 500;
  color: #cccccc;
  text-transform: uppercase;
`;

const LoaderWrapper = styled.div`
  position: absolute;
  top: -${rem(32)};
  right: -${rem(16)};
`;

export { ProductPriceCart };
